export default "__VITE_ASSET__Bh_1fzoT__"